
jQuery(document).ready(function($) {

    carouselFeatured = $("#carousel-testimonials").owlCarousel({
        items:3,
        mouseDrag: false,
        nav:true,
        dots: true,
        autoplay: false,
        autoplayHoverPause: false,
        smartSpeed: 600,
        dotsSpeed: 270,
        loop: true,
        margin: 32,
        navText: ['<span class="icon-arrow-left"></span>','<span class="icon-arrow-right"></span>'],
        responsive:{
            0:{
                items:1,
                margin: 0
            },            
            480:{
                items:2,
                margin: 16 
            },
            768:{
                items:3,
                margin: 16 
            },
            1024:{
                items:3,
                margin: 32
            },
            1366:{
                items:3,
                margin: 32
            }
        }
    });

    var $body = $('body'),
        $html = $('html'),
        $modal = $('#modal-testimonials'),
        modalSelector = '#modal-testimonials',
        readmoreSelector = ".read-more",
        closeSelector = ".modal-close"
        ;

    function modalOpen() {
       
       var content = {
            'title' : $(this).siblings('.title').html(),
            'body' : $(this).siblings('.modal-content').html()
        };
 
        $modal
            .addClass('modal-active')
            .find('.modal-body')
            .html(content.body)
            .end()
            .find('.modal-title')
            .html(content.title)
            ;
        
        $html
            .css('overflow', 'hidden')
            ;
    }

    function modalClose(e) {

        var $target = $(e.target);
        
        if ($target.hasClass('modal-container') || $target.hasClass('modal-body')) return;

        $modal
            .removeClass('modal-active')
            ;
        $html
            .css('overflow', 'visible')
            ;
    }

    $body
        .on('click', readmoreSelector, modalOpen)
        .on('click', closeSelector, modalClose)
        .on('click', modalSelector, modalClose)
        ;

});